'use strict';

function defaultNewDate() {
  return new Date;
}

module.exports = defaultNewDate;


// WEBPACK FOOTER //
// ./~/sugar-date/date/internal/defaultNewDate.js